import { useMutation } from '@tanstack/react-query';
import { axiosClient } from '../axiosClient';

const usePasswordReset = () => {
  return useMutation({
    mutationFn: async (
      email: string
    ): Promise<unknown | null> => {
      if (!email) return null;

      const URL = `${import.meta.env.VITE_API_RESET_PASSWORD_URL}?email=${email}`;

      try {
        const { data } = await axiosClient.post<unknown>(URL);
        return data;
      } catch (error: any) {
        // When API returns an error (like 403), extract the response body
        // which contains {"status":"error","message":"..."}
        if (error.response && error.response.data) {
          return error.response.data;
        }
        throw error;
      }
    },
  });
};

export default usePasswordReset;
